import { render } from "./markingMaterial.vue?vue&type=template&id=0d019528&scoped=true"
import script from "./markingMaterial.vue?vue&type=script&lang=js"
export * from "./markingMaterial.vue?vue&type=script&lang=js"

import "./markingMaterial.vue?vue&type=style&index=0&id=0d019528&lang=scss&scoped=true"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d019528"]])

export default __exports__